export const PUBLIC_ROUTES = {
	PROPERTY: "/:slug",
	CONTRACT_SIGN: "/contracts/sign/:token",
	PAYMENT_SUCCESS: "/payment/success",
} as const;
